
import React from 'react'
import { Component } from 'react'

import SearchLink from 'cms_plugins/expert_search/js/components/SearchLink'
import MultiSelector from "../../../expert_search/js/components/MultiSelector";


export const TABS_CHOICES = ["Zitat", "Typisierung", "Dinge"];

const DESC_LENGTH = 150

class ZitatAuszug extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: { "Zitat": true }
        }
    }


    render() {
        const {
            pk, year, text_html, metapher, source, things, comment,
            zitat_edit_url, className, onClick
        } = this.props;

        return (
            <div className={"zitat-auszug grid-x"+(className? " "+ className: "")} id={"zitat-" + pk} onClick={()=>onClick(pk)}>
                <div className={"small-12 cell"}>

                    {zitat_edit_url && <a
                        className={"changelink"}
                        href={zitat_edit_url}
                        target={"_blank"}
                        title={"Beleganalyse bearbeiten"}
                    >ID-{pk}</a>}

                    <div>
                        <div className={"text"}>
                            <span className={"quotes-left"} />
                            <span dangerouslySetInnerHTML={{ __html: text_html }} />
                            <span className={"quotes-right"} />
                        </div>
                    </div>
                    <div className={"shrink"}></div>
                    <div className="quelle">
                        {source.link
                            ? <a href={source.link} target={"_blank"} className={"source external-link"}>
                                {source.citation}
                            </a>
                            : <span className={"source"}>{source.citation}</span>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ZitatAuszug;


// WEBPACK FOOTER //
// ./cms_plugins/startseite_auszug/js/components/ZitatAuszug.js